
export enum REFUND_EVENT_STATUS_ID {
    ISSUED = 301,
    ISSUED_302 = 302,
    SUBMITTED = 303,
    REJECTED = 304,
    COMPLETED = 305,
    CANCELLED = 307,
    NOT_SUBMITTED = 308,
    PENDING = 309,
    APPROVED_BY_L1 = 310,
    APPROVED_BY_L2 = 311,
    APPROVED_BY_L3 = 312,
    APPROVED_BY_L4 = 313,
    APPROVED_BY_L5 = 314,
    APPROVED_BY_L6 = 315,
    NOTIFIED = 330,
    REFUNDED = 331,
}

export enum REFUND_EVENT_STATUS_LABEL {
    ISSUED = 'Issued',
    ISSUED_302 = 'Issued',
    SUBMITTED = 'Submitted',
    REJECTED = 'Rejected',
    COMPLETED = 'Completed',
    CANCELLED = 'Cancelled',
    NOT_SUBMITTED = 'Not Submitted',
    PENDING = 'Pending',
    APPROVED_BY_L1 = 'Approved By L1',
    APPROVED_BY_L2 = 'Approved By L2',
    APPROVED_BY_L3 = 'Approved By L3',
    APPROVED_BY_L4 = 'Approved By L4',
    APPROVED_BY_L5 = 'Approved By L5',
    APPROVED_BY_L6 = 'Approved By L6',
    REJECTED_BY_L1 = 'Rejected By L1',
    REJECTED_BY_L2 = 'Rejected By L2',
    NOTIFIED = 'Notified',
    REFUNDED = 'Refunded',
}
